import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { store } from "redux/store/store";
import CacheBuster from "./CacheBuster";
import App from "./App";
import { authConfig } from "shared/constants";

import "react-toastify/dist/ReactToastify.css";
import "semantic-ui-css/semantic.min.css";
import "./styles/index.scss";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        return (
          isLatestVersion && (
            <BrowserRouter>
              <AuthProvider
                {...authConfig}
                onSigninCallback={() => {
                  window.history.replaceState({}, document.title, "/");
                }}
              >
                <App />
              </AuthProvider>
            </BrowserRouter>
          )
        );
      }}
    </CacheBuster>
  </Provider>
);
